import { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { addHours, isAfter, secondsToMilliseconds } from 'date-fns';

import { selectCurrentTime } from 'store/timer/selectors';
import { getEntitlements } from 'store/user/actions';
import { selectEntitlementsRequestStatus } from 'store/user/selectors';
import { RequestStatus } from 'store/utils';

const ENTITLEMENTS_UPDATE_INTERVAL = 3;

function useEntitlementsIntervalUpdate() {
    const dispatch = useDispatch();

    const currentTime = useSelector(selectCurrentTime); // seconds
    const entitlementsRequestStatus = useSelector(
        selectEntitlementsRequestStatus,
    );

    const [entitlementsUpdateTime, setEntitlementsUpdateTime] = useState<
        Date | undefined
    >();
    const prevEntitlementsRequestStatus =
        useRef<typeof entitlementsRequestStatus>(undefined);

    useEffect(() => {
        if (
            entitlementsRequestStatus === RequestStatus.SUCCESS &&
            prevEntitlementsRequestStatus.current !== RequestStatus.SUCCESS
        ) {
            setEntitlementsUpdateTime(
                addHours(Date.now(), ENTITLEMENTS_UPDATE_INTERVAL),
            );
        }

        prevEntitlementsRequestStatus.current = entitlementsRequestStatus;
    }, [entitlementsRequestStatus]);

    useEffect(() => {
        if (
            entitlementsUpdateTime &&
            isAfter(
                new Date(secondsToMilliseconds(currentTime)),
                entitlementsUpdateTime,
            )
        ) {
            dispatch(getEntitlements({ autoRetry: true }));
        }
    }, [currentTime]);
}

export default useEntitlementsIntervalUpdate;
